/* ============================================================
   PES Supply — Enhanced Product Detail Page (PDP) JavaScript
   Added: July 31, 2026
   Features: Tabs, Gallery zoom/lightbox, Qty selector,
             Sticky mobile ATC, FBT add-all, smooth scroll
   ============================================================ */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------- 1. Tab Switching ---------- */
  function initTabs() {
    var tabBtns = document.querySelectorAll('.pes-pdp-tab-btn');
    var tabPanels = document.querySelectorAll('.pes-pdp-tab-panel');
    if (!tabBtns.length) return;

    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-tab');
        tabBtns.forEach(function (b) { b.classList.remove('active'); });
        tabPanels.forEach(function (p) { p.classList.remove('active'); });
        btn.classList.add('active');
        var panel = document.getElementById(target);
        if (panel) panel.classList.add('active');
      });
    });
  }

  /* ---------- 2. Image Gallery: thumbnail, zoom, lightbox ---------- */
  function initGallery() {
    var mainImg = document.querySelector('.pes-pdp-gallery-main img');
    var thumbs = document.querySelectorAll('.pes-pdp-thumb');
    if (!mainImg && !thumbs.length) {
      // Fallback: enhance Dawn native gallery thumbnails
      var nativeThumbs = document.querySelectorAll('.thumbnail-list .thumbnail');
      var nativeMain = document.querySelector('.product__modal-opener img, .product__media img');
      nativeThumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var img = thumb.querySelector('img');
          if (img && nativeMain) {
            var srcset = img.getAttribute('srcset') || img.src;
            var hiRes = srcset.split(',').pop().trim().split(' ')[0];
            nativeMain.src = hiRes || img.src;
          }
        });
      });
    }

    // Thumbnail click
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function (e) {
        e.preventDefault();
        var fullSrc = thumb.getAttribute('data-full') || thumb.querySelector('img').src;
        var mainEl = document.querySelector('.pes-pdp-gallery-main img');
        if (mainEl) {
          mainEl.src = fullSrc;
          mainEl.setAttribute('data-full', fullSrc);
        }
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });

    // Lightbox
    var lightbox = document.createElement('div');
    lightbox.className = 'pes-pdp-lightbox';
    lightbox.innerHTML =
      '<span class="pes-pdp-lightbox-close" aria-label="Close">&times;</span>' +
      '<span class="pes-pdp-lightbox-nav prev" aria-label="Previous">&#8249;</span>' +
      '<img alt="">' + // PES fix: no empty src (fired a bogus request + error event on every PDP)
      '<span class="pes-pdp-lightbox-nav next" aria-label="Next">&#8250;</span>';
    document.body.appendChild(lightbox);

    var lbImg = lightbox.querySelector('img');
    var galleryImages = [];
    var currentIndex = 0;

    function collectImages() {
      galleryImages = [];
      document.querySelectorAll('.pes-pdp-thumb img, .pes-pdp-gallery-main img').forEach(function (img) {
        var src = img.getAttribute('data-full') || img.src;
        if (galleryImages.indexOf(src) === -1) galleryImages.push(src);
      });
      // Also include Dawn native gallery
      if (!galleryImages.length) {
        document.querySelectorAll('.product__media img').forEach(function (img) {
          var srcset = img.getAttribute('srcset') || img.src;
          var hi = srcset.split(',').pop().trim().split(' ')[0] || img.src;
          if (galleryImages.indexOf(hi) === -1) galleryImages.push(hi);
        });
      }
    }

    function showLb(index) {
      if (!galleryImages.length) collectImages();
      if (!galleryImages.length) return;
      currentIndex = (index + galleryImages.length) % galleryImages.length;
      lbImg.src = galleryImages[currentIndex];
      lightbox.classList.add('active');
    }

    function closeLb() { lightbox.classList.remove('active'); }

    // Open lightbox on main image click
    var zoomTarget = document.querySelector('.pes-pdp-gallery-zoom, .pes-pdp-gallery-main');
    if (zoomTarget) {
      zoomTarget.addEventListener('click', function () {
        collectImages();
        showLb(currentIndex);
      });
    } else {
      // Dawn native: open on media click
      var nativeMedia = document.querySelector('.product__media img');
      if (nativeMedia) {
        nativeMedia.style.cursor = 'zoom-in';
        nativeMedia.addEventListener('click', function (e) {
          // Don't interfere if Dawn's own modal handles it
          if (e.target.closest('modal-opener') || e.target.closest('[data-product-media]')) return;
          collectImages();
          showLb(0);
        });
      }
    }

    lightbox.querySelector('.pes-pdp-lightbox-close').addEventListener('click', closeLb);
    lightbox.querySelector('.pes-pdp-lightbox-nav.prev').addEventListener('click', function (e) {
      e.stopPropagation(); showLb(currentIndex - 1);
    });
    lightbox.querySelector('.pes-pdp-lightbox-nav.next').addEventListener('click', function (e) {
      e.stopPropagation(); showLb(currentIndex + 1);
    });
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLb();
    });
    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('active')) return;
      if (e.key === 'Escape') closeLb();
      else if (e.key === 'ArrowLeft') showLb(currentIndex - 1);
      else if (e.key === 'ArrowRight') showLb(currentIndex + 1);
    });
  }

  /* ---------- 3. Quantity Selector +/- buttons ---------- */
  function initQuantity() {
    // Enhance existing Dawn quantity-input if our custom selector isn't present
    var customInputs = document.querySelectorAll('.pes-pdp-qty-selector input');
    customInputs.forEach(function (input) {
      var wrap = input.closest('.pes-pdp-qty-selector');
      var minus = wrap.querySelector('button[name="minus"]');
      var plus = wrap.querySelector('button[name="plus"]');
      var min = parseInt(input.getAttribute('data-min') || input.min || 1, 10);
      var step = parseInt(input.getAttribute('data-step') || input.step || 1, 10);
      var max = parseInt(input.getAttribute('data-max') || input.max || 0, 10);

      function syncDawn() {
        var dawnInput = document.querySelector('input[name="quantity"].quantity__input');
        if (dawnInput && dawnInput !== input) {
          dawnInput.value = input.value;
          dawnInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      if (minus) minus.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || min;
        v = Math.max(min, v - step);
        input.value = v;
        syncDawn();
        updateBulkPricing(v);
      });
      if (plus) plus.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || min;
        v = v + step;
        if (max > 0) v = Math.min(max, v);
        input.value = v;
        syncDawn();
        updateBulkPricing(v);
      });
      input.addEventListener('change', function () { updateBulkPricing(parseInt(input.value, 10)); });
    });
  }

  /* Bulk pricing live update based on qty */
  function updateBulkPricing(qty) {
    var tiers = document.querySelectorAll('.pes-pdp-bulk-tiers tbody tr');
    if (!tiers.length) return;
    var activeRow = null;
    tiers.forEach(function (row) {
      var min = parseInt(row.getAttribute('data-min'), 10) || 0;
      row.classList.remove('pes-bulk-active');
      if (qty >= min) activeRow = row;
    });
    if (activeRow) activeRow.classList.add('pes-bulk-active');
  }

  /* ---------- 4. Sticky Add-to-Cart (mobile) ---------- */
  function initStickyATC() {
    var stickyBar = document.querySelector('.pes-pdp-sticky-atc');
    if (!stickyBar) return;
    var atcBtn = document.querySelector('.product-form__submit, .pes-pdp-atc-btn');
    if (!atcBtn) { stickyBar.style.display = 'none'; return; }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          stickyBar.classList.remove('active');
        } else {
          // Only show when scrolled past the ATC button
          if (window.scrollY > atcBtn.offsetTop) {
            stickyBar.classList.add('active');
          }
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -100px 0px' });
    observer.observe(atcBtn);

    var stickyBtn = stickyBar.querySelector('.pes-sticky-btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var mainATC = document.querySelector('.product-form__submit, .pes-pdp-atc-btn');
        if (mainATC) {
          mainATC.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(function () { mainATC.click(); }, 600);
        }
      });
    }
  }

  /* ---------- 5. Frequently Bought Together — add all ---------- */
  function initFBT() {
    var fbtWrap = document.querySelector('.pes-pdp-fbt');
    if (!fbtWrap) return;
    var checkboxes = fbtWrap.querySelectorAll('.pes-fbt-item input[type="checkbox"]');
    var addAllBtn = fbtWrap.querySelector('.pes-pdp-fbt-add-all');
    var totalEl = fbtWrap.querySelector('.pes-fbt-total-price');
    if (!addAllBtn) return;

    function recalcTotal() {
      var total = 0;
      checkboxes.forEach(function (cb) {
        if (cb.checked) {
          var price = parseFloat(cb.getAttribute('data-price') || 0);
          total += price;
        }
      });
      if (totalEl) {
        totalEl.textContent = '$' + total.toFixed(2);
      }
    }

    checkboxes.forEach(function (cb) {
      cb.addEventListener('change', recalcTotal);
    });
    recalcTotal();

    addAllBtn.addEventListener('click', function () {
      var items = [];
      checkboxes.forEach(function (cb) {
        if (cb.checked) {
          var id = cb.getAttribute('data-variant-id');
          var qty = parseInt(cb.getAttribute('data-qty') || 1, 10);
          if (id) items.push({ id: parseInt(id, 10), quantity: qty });
        }
      });
      if (!items.length) {
        // If none checked, add all
        checkboxes.forEach(function (cb) {
          var id = cb.getAttribute('data-variant-id');
          if (id) items.push({ id: parseInt(id, 10), quantity: 1 });
        });
      }
      if (!items.length) return;

      addAllBtn.disabled = true;
      addAllBtn.textContent = 'Adding...';

      fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function () {
          addAllBtn.disabled = false;
          addAllBtn.textContent = 'Add Selected to Cart';
        });
    });
  }

  /* ---------- 6. Smooth scroll to tabs / reviews ---------- */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#pes-tab-"], a[href^="#pes-reviews"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href');
        var target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          // If it's a tab, activate it
          var tabPanel = target.closest('.pes-pdp-tab-panel');
          if (tabPanel) {
            var tabId = tabPanel.id;
            var tabBtn = document.querySelector('.pes-pdp-tab-btn[data-tab="' + tabId + '"]');
            if (tabBtn) tabBtn.click();
          }
        }
      });
    });
  }

  /* ---------- 7. Auto-wrap existing content into tabs ---------- */
  function enhanceExistingContent() {
    var tabContainer = document.querySelector('.pes-pdp-tabs');
    if (!tabContainer) return;

    // Move existing description into Description tab if empty
    var descPanel = document.getElementById('pes-tab-desc');
    if (descPanel && !descPanel.innerHTML.trim()) {
      var desc = document.querySelector('.product__description');
      if (desc) {
        descPanel.appendChild(desc.cloneNode(true));
      }
    }

    // Move existing specification table into Specs tab if empty
    var specPanel = document.getElementById('pes-tab-specs');
    if (specPanel && !specPanel.innerHTML.trim()) {
      var spec = document.querySelector('.specification');
      if (spec) {
        specPanel.appendChild(spec.cloneNode(true));
      }
    }

    // Move Judgeme reviews into Reviews tab if empty
    var reviewPanel = document.getElementById('pes-tab-reviews');
    if (reviewPanel && !reviewPanel.innerHTML.trim()) {
      var reviews = document.querySelector('.pes-judgeme-reviews');
      if (reviews) {
        reviewPanel.appendChild(reviews.cloneNode(true));
      }
    }
  }

  /* ---------- Init all ---------- */
  ready(function () {
    initTabs();
    initGallery();
    initQuantity();
    initStickyATC();
    initFBT();
    initSmoothScroll();
    // Delay content enhancement to ensure all app blocks (Judge.me) have rendered
    setTimeout(enhanceExistingContent, 800);
  });
})();
